export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 3,
    "title": "What is the core model architecture used in modern generative AI systems?",
    "description": "Transformer-based architecture"
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "True/False: Explainable AI (XAI) helps make AI systems more understandable and transparent.",
    "description": "True"
  },
  {
    "id": 3,
    "topic_id": 3,
    "title": "An AI model with unknown internal workings is often called a ________.",
    "description": "Black box"
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "Which machine learning method uses reward feedback to improve decisions over time?",
    "description": "Reinforcement learning"
  },
  {
    "id": 5,
    "topic_id": 3,
    "title": "True/False: Deep learning models typically use a small number of hidden layers.",
    "description": "False. Deep learning models often use many hidden layers."
  },
  {
    "id": 6,
    "topic_id": 3,
    "title": "True/False: Generative AI models have real-time knowledge of current events.",
    "description": "False. Generative AI models are trained on static datasets and may not reflect recent information unless they are connected to live sources. Although, more advanced systems, like ChatGPT, can search the Internet—but this is not about the training of its models."
  },
  {
    "id": 7,
    "topic_id": 3,
    "title": "Fill in the blank: AI coding systems typically generate code by predicting the most likely next ________.",
    "description": "Token"
  },
  {
    "id": 8,
    "topic_id": 6,
    "title": "True/False: Security flaws like SQL injections can occur in AI-generated code.",
    "description": "True"
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "Which Microsoft responsible AI principle focuses on protecting user data?",
    "description": "Privacy and security"
  },
  {
    "id": 10,
    "topic_id": 3,
    "title": "True/False: AI coding models fully understand software architecture when generating code.",
    "description": "False. AI models predict patterns but do not inherently understand architecture."
  },
  {
    "id": 11,
    "topic_id": 3,
    "title": "What is the main reason why benchmarks like SWE-bench are used?",
    "description": "To evaluate the code-generation abilities of AI models using real-world software development tasks."
  },
  {
    "id": 12,
    "topic_id": 1,
    "title": "True/False: Responsible AI means designing systems that consider social, legal, and ethical impacts.",
    "description": "True"
  },
  {
    "id": 13,
    "topic_id": 3,
    "title": "Fill in the blank: A ________ is used to split sentences into tokens for AI processing.",
    "description": "Tokenizer"
  },
  {
    "id": 14,
    "topic_id": 3,
    "title": "True/False: Deep learning models can process raw data like images and sound directly without much manual feature extraction.",
    "description": "True"
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "What is the key difference between supervised and unsupervised learning?",
    "description": "Supervised learning uses labeled data; unsupervised learning uses unlabeled data to find patterns."
  },
  {
    "id": 16,
    "topic_id": 2,
    "title": "True/False: GitHub Copilot can be integrated into both IDEs and the command line interface (CLI).",
    "description": "True"
  },
  {
    "id": 17,
    "topic_id": 2,
    "title": "Fill in the blank: The ________ plan of GitHub Copilot offers the highest level of security, compliance, and private customization.",
    "description": "Copilot Enterprise"
  },
  {
    "id": 18,
    "topic_id": 2,
    "title": "True/False: Developers must host their code on GitHub to use GitHub Copilot.",
    "description": "False. Developers can use GitHub Copilot even with other platforms like GitLab or Bitbucket."
  },
  {
    "id": 19,
    "topic_id": 2,
    "title": "What does the slash command /fix do in GitHub Copilot Chat?",
    "description": "It suggests fixes for issues detected in the selected code."
  },
  {
    "id": 20,
    "topic_id": 2,
    "title": "Fill in the blank: The GitHub Copilot feature that allows AI-driven code modifications across multiple files is called ________.",
    "description": "Edits"
  },
  {
    "id": 21,
    "topic_id": 2,
    "title": "Fill in the blank: GitHub Copilot ________ allows you to reference the structure of your project’s codebase to enhance prompt results.",
    "description": "@workspace"
  },
  {
    "id": 22,
    "topic_id": 2,
    "title": "Fill in the blank: GitHub Copilot can generate ________ text in the editor, known as suggested code completions.",
    "description": "Ghost"
  },
  {
    "id": 23,
    "topic_id": 6,
    "title": "What GitHub Copilot feature helps developers create new unit tests quickly?",
    "description": "The /test slash command"
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "Fill in the blank: The ________ slash command in GitHub Copilot Chat can generate fixes for test failures.",
    "description": "/fixtestfailure"
  },
  {
    "id": 25,
    "topic_id": 2,
    "title": "True/False: GitHub Copilot Chat can reference active files or specific selections in the IDE using chat variables like #editor and #selection.",
    "description": "True"
  },
  {
    "id": 26,
    "topic_id": 2,
    "title": "What GitHub Copilot feature allows interaction with Azure services directly within Visual Studio Code?",
    "description": "@azure"
  },
  {
    "id": 27,
    "topic_id": 2,
    "title": "Fill in the blank: The GitHub Copilot CLI extension is installed using the ________ command-line tool.",
    "description": "GitHub CLI (gh)"
  },
  {
    "id": 28,
    "topic_id": 2,
    "title": "True/False: GitHub Copilot Chat can accept voice input for prompts.",
    "description": "True"
  },
  {
    "id": 29,
    "topic_id": 2,
    "title": "Fill in the blank: In GitHub Copilot, the ________ reference allows interaction with the IDE’s terminal window.",
    "description": "@terminal"
  },
  {
    "id": 30,
    "topic_id": 2,
    "title": "True/False: Pull request summaries are available in GitHub Copilot Individual, Business, and Enterprise editions.",
    "description": "True"
  },
  {
    "id": 31,
    "topic_id": 2,
    "title": "What feature does GitHub Copilot Enterprise offer to improve code quality, consistency, and efficiency?",
    "description": "Knowledge bases"
  },
  {
    "id": 32,
    "topic_id": 2,
    "title": "True/False: GitHub Copilot Individual provides centralized billing for organizations.",
    "description": "False"
  },
  {
    "id": 33,
    "topic_id": 2,
    "title": "What legal protection is offered with GitHub Copilot Business and Enterprise editions?",
    "description": "Intellectual property (IP) indemnity"
  },
  {
    "id": 34,
    "topic_id": 2,
    "title": "True/False: GitHub Copilot Individual supports organization-wide policy management.",
    "description": "False"
  },
  {
    "id": 35,
    "topic_id": 2,
    "title": "What can organizations use to automate subscription management and retrieve usage metrics for GitHub Copilot?",
    "description": "GitHub Copilot REST API"
  },
  {
    "id": 36,
    "topic_id": 2,
    "title": "Fill in the blank: In GitHub Copilot Enterprise, ________ models allow fine-tuning the LLM to an organization’s specific coding standards.",
    "description": "Custom"
  },
  {
    "id": 37,
    "topic_id": 7,
    "title": "What is the purpose of the public code filter with code referencing in GitHub Copilot?",
    "description": "To detect and flag AI-generated code that matches public GitHub repositories to avoid IP violations."
  },
  {
    "id": 38,
    "topic_id": 2,
    "title": "True/False: GitHub Copilot Business users can manage access and seat assignments through organization settings.",
    "description": "True"
  },
  {
    "id": 39,
    "topic_id": 2,
    "title": "True/False: Knowledge bases in GitHub Copilot Enterprise can include API documentation and style guides.",
    "description": "True"
  },
  {
    "id": 40,
    "topic_id": 2,
    "title": "True/False: Developers can create prompt files to reuse common instructions in GitHub Copilot Individual.",
    "description": "True"
  },
  {
    "id": 41,
    "topic_id": 2,
    "title": "Fill in the blank: GitHub Copilot Business and Enterprise provide ________ logs to help with security and compliance tracking.",
    "description": "Audit"
  },
  {
    "id": 42,
    "topic_id": 2,
    "title": "Fill in the blank: The ________ slash command in GitHub Copilot Chat is used to quickly create a new Jupyter notebook.",
    "description": "/newNotebook"
  },
  {
    "id": 43,
    "topic_id": 7,
    "title": "Fill in the blank: The ________ feature in GitHub Copilot flags AI-generated code that resembles open-source code from GitHub repositories.",
    "description": "public code filter"
  },
  {
    "id": 44,
    "topic_id": 7,
    "title": "True/False: GitHub Copilot Business allows administrators to exclude files at the repository or organization level.",
    "description": "True"
  },
  {
    "id": 45,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot immediately discards user input data after processing unless the user opts in for training.",
    "description": "True"
  },
  {
    "id": 46,
    "topic_id": 7,
    "title": "Fill in the blank: GitHub Copilot uses a ________ service to filter prompts and protect sensitive information.",
    "description": "Proxy"
  },
  {
    "id": 47,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot can operate in air-gapped environments without Internet access.",
    "description": "False"
  },
  {
    "id": 48,
    "topic_id": 3,
    "title": "Fill in the blank: ________ data includes details like user interactions, feature usage, and error reports collected by GitHub Copilot.",
    "description": "Telemetry"
  },
  {
    "id": 49,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot improves accuracy by analyzing active file content, open tabs, comments, and metadata.",
    "description": "True"
  },
  {
    "id": 50,
    "topic_id": 3,
    "title": "What is one key reason GitHub Copilot struggles with complex mathematical calculations?",
    "description": "It lacks a dedicated math engine."
  },
  {
    "id": 51,
    "topic_id": 3,
    "title": "Fill in the blank: In GitHub Copilot, ________ windows limit how much surrounding code the model can process at once.",
    "description": "Context"
  },
  {
    "id": 52,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot’s post-processing stage adjusts code for formatting issues like indentation and syntax.",
    "description": "True"
  },
  {
    "id": 53,
    "topic_id": 3,
    "title": "What does GitHub Copilot prioritize when generating code suggestions to minimize latency?",
    "description": "The content of the active file"
  },
  {
    "id": 54,
    "topic_id": 7,
    "title": "Which feature in GitHub Copilot helps detect AI-generated code that matches public repositories?",
    "description": "Code referencing filter"
  },
  {
    "id": 55,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot’s generated code suggestions are always free from syntax errors without post-processing.",
    "description": "False"
  },
  {
    "id": 56,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot’s suggestions can exhibit bias toward popular frameworks and coding patterns.",
    "description": "True"
  },
  {
    "id": 57,
    "topic_id": 3,
    "title": "Fill in the blank: In GitHub Copilot, ________ information includes file paths, programming languages, and repository data.",
    "description": "Metadata"
  },
  {
    "id": 58,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot processes user prompts locally without sending them to the cloud.",
    "description": "False"
  },
  {
    "id": 59,
    "topic_id": 7,
    "title": "True/False: GitHub Copilot Individual users can opt in to allow their data to be used for model improvements.",
    "description": "True"
  },
  {
    "id": 60,
    "topic_id": 4,
    "title": "True/False: Prompt crafting and prompt engineering both refer to creating clear and specific prompts for LLMs.",
    "description": "True"
  },
  {
    "id": 61,
    "topic_id": 4,
    "title": "Fill in the blank: The four parts of a prompt are context, instructions, input of content, and ________.",
    "description": "Format"
  },
  {
    "id": 62,
    "topic_id": 4,
    "title": "True/False: Zero-shot learning provides examples to the LLM within the prompt.",
    "description": "False"
  },
  {
    "id": 63,
    "topic_id": 4,
    "title": "What technique involves breaking down a task into smaller steps to improve LLM problem-solving?",
    "description": "Chain-of-Thought (CoT) prompting"
  },
  {
    "id": 64,
    "topic_id": 4,
    "title": "Fill in the blank: ________ learning involves providing several examples in a prompt to guide the LLM’s output.",
    "description": "Few-shot"
  },
  {
    "id": 65,
    "topic_id": 4,
    "title": "What can you use in prompts to help LLMs separate instructions from content?",
    "description": "Delimiters like ### or quotation marks"
  },
  {
    "id": 66,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot uses chat history to help create more context-aware responses.",
    "description": "True"
  },
  {
    "id": 67,
    "topic_id": 4,
    "title": "True/False: Agentic AI is expected to reduce the need for complex prompt engineering in the future.",
    "description": "True"
  },
  {
    "id": 68,
    "topic_id": 4,
    "title": "True/False: In GitHub Copilot, you usually do not need to specify the programming language when writing a prompt.",
    "description": "True"
  },
  {
    "id": 69,
    "topic_id": 2,
    "title": "True/False: GitHub Copilot supports code generation for a wide variety of programming languages.",
    "description": "True"
  },
  {
    "id": 70,
    "topic_id": 3,
    "title": "True/False: Multimodal systems can combine text, images, sound, and video.",
    "description": "True"
  },
  {
    "id": 71,
    "topic_id": 3,
    "title": "True/False: Even clear prompts can sometimes produce inaccurate outputs because of limitations in training data.",
    "description": "True"
  },
  {
    "id": 72,
    "topic_id": 4,
    "title": "True/False: Prompt engineering requires a mix of creativity and technical skill.",
    "description": "True"
  },
  {
    "id": 73,
    "topic_id": 4,
    "title": "True/False: Prompt libraries can help inspire ideas and improve the quality of your prompts.",
    "description": "True"
  },
  {
    "id": 74,
    "topic_id": 5,
    "title": "True/False: GitHub Copilot can help you create study guides and coding challenges for learning new languages.",
    "description": "True"
  },
  {
    "id": 75,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot can automatically create files when generating code.",
    "description": "False"
  },
  {
    "id": 76,
    "topic_id": 5,
    "title": "What type of code optimization improves maintainability without changing functionality?",
    "description": "Code refactoring"
  },
  {
    "id": 77,
    "topic_id": 5,
    "title": "True/False: GitHub Copilot can generate SQL database schemas and queries using natural language prompts.",
    "description": "True"
  },
  {
    "id": 78,
    "topic_id": 2,
    "title": "Fill in the blank: Regular expressions (regex) can be explained by GitHub Copilot using the ________ command.",
    "description": "/explain"
  },
  {
    "id": 79,
    "topic_id": 3,
    "title": "What is one limitation when using GitHub Copilot to find dead code?",
    "description": "It may not have full context due to a limited context window size."
  },
  {
    "id": 80,
    "topic_id": 6,
    "title": "True/False: GitHub Copilot can generate realistic test data in formats like JSON for applications.",
    "description": "True"
  },
  {
    "id": 81,
    "topic_id": 2,
    "title": "True/False: GitHub Copilot can directly deploy applications to Azure using an integrated extension.",
    "description": "True"
  },
  {
    "id": 82,
    "topic_id": 4,
    "title": "Fill in the blank: In GitHub Copilot, ________ conditionals refers to breaking complex conditionals into smaller, manageable functions.",
    "description": "Decomposing"
  },
  {
    "id": 83,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot is better suited for fixing concurrency errors than syntax or logic errors.",
    "description": "False"
  },
  {
    "id": 84,
    "topic_id": 5,
    "title": "True/False: GitHub Copilot can help generate REST API documentation in Markdown format.",
    "description": "True"
  },
  {
    "id": 85,
    "topic_id": 5,
    "title": "True/False: GitHub Copilot can directly generate Docker deployment scripts.",
    "description": "True"
  },
  {
    "id": 86,
    "topic_id": 5,
    "title": "True/False: GitHub Copilot can detect code smells and suggest refactoring opportunities.",
    "description": "True"
  },
  {
    "id": 87,
    "topic_id": 3,
    "title": "True/False: GitHub Copilot can automatically fix syntax errors during initial code generation.",
    "description": "False"
  },
  {
    "id": 88,
    "topic_id": 5,
    "title": "True/False: You can use GitHub Copilot to highlight and suggest removal of unused variables in a codebase.",
    "description": "True"
  },
  {
    "id": 89,
    "topic_id": 6,
    "title": "True/False: GitHub Copilot can help generate unit and integration tests, and it can assist with identifying edge cases.",
    "description": "True"
  },
  {
    "id": 90,
    "topic_id": 6,
    "title": "Fill in the blank: In software testing, ________ testing focuses on verifying individual units of code in isolation.",
    "description": "Unit"
  },
  {
    "id": 91,
    "topic_id": 6,
    "title": "What slash command can you use in GitHub Copilot to automatically generate unit tests?",
    "description": "/tests"
  },
  {
    "id": 92,
    "topic_id": 2,
    "title": "True/False: GitHub Copilot’s /tests slash command can be customized to select a specific testing framework.",
    "description": "False"
  },
  {
    "id": 93,
    "topic_id": 6,
    "title": "What type of testing evaluates how different components of an application interact with each other?",
    "description": "Integration testing"
  },
  {
    "id": 94,
    "topic_id": 6,
    "title": "True/False: Coverage tools can be used to identify untested parts of a codebase when using GitHub Copilot.",
    "description": "True"
  },
  {
    "id": 95,
    "topic_id": 7,
    "title": "Which privacy feature helps prevent sensitive files from being included in GitHub Copilot code suggestions?",
    "description": "Content exclusions"
  },
  {
    "id": 96,
    "topic_id": 6,
    "title": "True/False: Unit tests should be independent of one another to avoid cascading failures.",
    "description": "True"
  },
  {
    "id": 97,
    "topic_id": 6,
    "title": "True/False: GitHub Copilot can help create integration tests that mock external dependencies like APIs.",
    "description": "True"
  },
  {
    "id": 98,
    "topic_id": 2,
    "title": "True/False: GitHub Copilot Enterprise offers organization-wide policy management for better privacy controls.",
    "description": "True"
  },
  {
    "id": 99,
    "topic_id": 2,
    "title": "What type of configuration file in VS Code allows developers to customize GitHub Copilot’s behavior?",
    "description": "Settings.json"
  },
  {
    "id": 100,
    "topic_id": 3,
    "title": "What is GitHub’s position regarding the ownership of code generated by GitHub Copilot?",
    "description": "Users own their generated code."
  },
  {
    "id": 101,
    "topic_id": 6,
    "title": "True/False: GitHub Copilot can help detect security vulnerabilities like cross-site scripting (XSS) through code analysis prompts.",
    "description": "True. However, depending on the complexity of the code, it could still sometimes miss identifying the issues. But, generally, you can use prompts to check on potential security vulnerabilities."
  },
  {
    "id": 102,
    "topic_id": 6,
    "title": "True/False: When using GitHub Copilot’s /tests command, the default testing framework is usually chosen based on common training data.",
    "description": "True"
  },
  {
    "id": 103,
    "topic_id": 7,
    "title": "What happens if content exclusions are not consistently applied across an organization and its repositories?",
    "description": "It can lead to unexpected exposure of sensitive files."
  },
  {
    "id": 104,
    "topic_id": 200,
    "title": "Understand the core concepts of GenAI and how they apply to AI coding.",
    "description": "GenAI is what creates the code, which is based on huge amounts of publicly available code from the Internet. The model does not know software development. Rather, the GenAI model essentially makes predictions based on the underlying data. Yet this often generates quality code. The probabilistic nature of GenAI tends to work well because programming languages are highly structured."
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Understand that AI coding does not always generate quality code.",
    "description": "An AI coding system may generate hallucinations, which is code that is false or misleading. In many cases, this is not a problem, as the compiler often finds the problems, yet some may slip through. The AI-generated code may be functionally correct but generate results you do not want. In other cases, the code may even have security flaws. There are also times when the code is bloated. This is why it’s important to always review AI-generated code before putting it into production."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Understand the risks of AI.",
    "description": "You need to understand how AI is vulnerable to problems with bias and security. You should also know about the principles of responsible AI, such as fairness, privacy, and transparency."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "Understand multimodel AI coding.",
    "description": "For the exam, you need to know that AI coding systems allow you to use different LLMs. For example, GitHub Copilot has access to Anthropic’s Claude 3.5 Sonnet, Google’s Gemini 1.5 Pro, and OpenAI’s o1-preview."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Understand the four plans of GitHub Copilot.",
    "description": "You should know about the core features. Some of them include chat, code completion, and inline chat. It’s also a good idea to learn about GitHub Copilot Edits, which is becoming increasingly important. Then you should review the different versions of the GitHub service and why this is required for using GitHub Copilot."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Know how the Chat feature works.",
    "description": "This includes many capabilities. You should understand how to activate Chat. You also need to know some of its key functions. These include slash commands and @ references. They allow for enhancing the prompts. You should also know how to attach files, which add context for the LLM."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Learn about the CLI.",
    "description": "You should know about how to install the CLI for GitHub Copilot. This is integrated in the GitHub CLI. It allows you to understand the numerous commands and to get recommendations for different scenarios. Finally, you should know about how you can configure the CLI."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "Understand pull request summaries.",
    "description": "These use GitHub Copilot’s LLM to generate pull requests. They are based on the relevant repositors. The system will evaluate up to 30 files."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "Learn about excluding data from being processed by GitHub Copilot.",
    "description": "You can exclude certain files from being accessed. This is done by changing the settings and specifying the file paths."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Know how audit logs work.",
    "description": "They monitor activities in GitHub Copilot. This can help improve compliance, security, and troubleshooting. The audit logs are provided at an organization level. They can also be searched by using various filters."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Understand the GitHub Copilot REST API.",
    "description": "This gives you access to usage patterns at a repository level. This can be used to create applications to automate processes, such as to evaluate an organization’s effectiveness with GitHub Copilot or helping to improve compliance. You can also use the REST API for managing subscriptions, such as with assignments and revocations."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Learn about knowledge bases.",
    "description": "These allow for embedding data into GitHub Copilot to improve its customization. This is done at an organization level. The information for knowledge bases can include many sources, like code snippets, best practices, and documentation. Some of the benefits are improved code reviews and code quality."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Understand custom models.",
    "description": "This is where you fine-tune the GitHub Copilot LLM. This provides a high level of customization, such as for your coding standards, procedures, and patterns."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Understand the data security features of GitHub Copilot.",
    "description": "A key benefit is that the tool is hosted on Azure. GitHub Copilot also secures data with encryption, for data in rest, in transit, and in use. There is even an AI-powered vulnerability prevention system to block insecure code. Another layer of security is a proxy filter, which blocks unwanted content."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Know about how GitHub Copilot Individual handles data.",
    "description": "For your prompts, the system will transmit them to GitHub’s servers for processing the response. But after this, the data is discarded. GitHub Copilot does not use this information for training its own LLMs."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Understand the data flow of GitHub Copilot.",
    "description": "There are four steps: prompt crafting, model processing, post-processing, and safety. These are for code completions and for Chat. However, in the case of Chat, the system will take longer to process a response. This is because users expect a more comprehensive explanation."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Learn about the limitations of GitHub Copilot when using data.",
    "description": "Be sure to know about how the context window can lead to less effective results. You should also understand the potential impact of the underlying dataset. This may lead to results that focus mostly on traditional approaches to software development and may not be as innovative. Then there is the impact of the cut-off data of a model, which can mean getting old software methods."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Understand reasoning and context versus calculations.",
    "description": "GitHub Copilot is usually better at handling tasks that require reasoning and context. However, it tends to fall short when doing strict mathematical calculations. The reason is the transformer model, which does not have a math engine."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Know the structure of a prompt.",
    "description": "There are four main steps. First, you set the context, such as the role or scenario for the LLM. Next, there are the instructions for the LLM. These are clear tasks to perform. Then there is input for the content. You can add details by using delimiters like ###. Finally, there is the format for the response, such as in JSON."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Learn the best practices for prompt engineering.",
    "description": "A prompt should be clear, which helps reduce hallucinations and provide for more relevant responses. You can also use few-shot learning. This is where you provide some examples in the prompt for more context. You can also use chain-of-thought (CoT) prompting, which is about breaking down a task into more understandable parts. This can help LLMs with the problem-solving process. Finally, even when you spend time crafting a prompt, the results can still be off. This is why it’s common to iterate."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Understand security with prompting.",
    "description": "In some cases, you may work with sensitive data when creating a prompt. You need to make sure you do not disclose this information."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Understand language support.",
    "description": "It’s not clear how many languages GitHub Copilot supports. But the system certainly can generate code from dozens of languages. However, the quality is dependent on the dataset. For some obscure languages, there may not be enough information to generate useful code."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Understand how to debug and refactor code using GitHub Copilot.",
    "description": "You can use this tool to identify logic errors, detect dead code, and refactor complex code blocks. This will help to improve code quality, readability, and maintainability."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Understand that you can use GitHub Copilot as a learning tool.",
    "description": "You can use prompts to ask questions about a language or framework. This can also be personalized, such as by having GitHub Copilot show examples of code snippets. It also can create study guides and code challenges."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Understand how you can use GitHub Copilot for documentation.",
    "description": "It can evaluate the context of your code and generate documentation, such as a user guide. You can also generate comments."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Learn about the data creation capabilities of GitHub Copilot.",
    "description": "You can create realistic test data for your application, such as for logins. You can do this in various formats like JSON. You can also use GitHub Copilot to create database schemas, such as for SQL scripts."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Know about the SDLC process with GitHub Copilot.",
    "description": "You should understand the main steps: requirements analysis, design and development, testing and quality assurance, deployment, and maintenance and support. You should also know how you can use GitHub Copilot for this process, such as using prompts to help deploy an application."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Understand the REST API.",
    "description": "You should know that this can provide access to metrics about the usage of GitHub Copilot. You should also understand that you can access the endpoints for enterprises, organizations, and teams."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Understand how GitHub Copilot improves software testing.",
    "description": "GitHub Copilot streamlines unit and integration testing. It will create the boilerplate code for the testing, which will be customized based on the function or block of code. You can also do this using a TDD workflow, allowing you to write tests before implementation. This can help improve reliability."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Learn how to use GitHub Copilot for unit testing.",
    "description": "GitHub can create unit tests for common use cases, edge cases, and error conditions. The /tests slash command allows you to do this quickly. But you can also use custom prompts, such as by specifying the testing framework and setting forth what you want tested."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Understand integration testing with GitHub Copilot.",
    "description": "GitHub Copilot can create integration tests that use mocks for external dependencies like APIs. You should know how to refine these tests for certain kinds of responses."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Know about how to use GitHub Copilot for security testing.",
    "description": "You can use GitHub Copilot to scan security vulnerabilities, such as SQL injection and cross-site scripting (XSS). This is done by using prompts. GitHub Copilot will not only spot the security issues but also suggest fixes."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Understand privacy settings and content exclusions.",
    "description": "You should know that GitHub Copilot can be configured to exclude files. This means that sensitive or proprietary data will not be used for suggestions. You should also understand that this can be done at an organizational level and for specified repositories. But you need to be careful. You do not want these to conflict. Otherwise, data may be exposed. You should also know that you can enable and disable automatic suggestions."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Know about troubleshooting Copilot issues.",
    "description": "In some cases, Copilot may not generate suggestions. You should know how to resolve this, such as by updating the Copilot extension, ensuring the correct settings are enabled, and troubleshooting context exclusions."
  }
];
